module.exports = __webpack_public_path__ + "static/media/dashboard_light.b82b2d3e.svg";